































import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { IColorSpecifiable, instanceOfIEnableSpecifiable } from "../../../../../../../base/domain/drawing";
import { IComboOption, IMovePageBehavior } from "../../../../../../../documaker/domain/format/objects";
import { IConfiguration } from "../../../../../../domain/configuration";

@Component
export default class ComboOptionSelector extends Mixins() {
  @Prop({ default: () => [] as IComboOption[] })
  options: IComboOption[];

  @Prop({ default: () => [] as number[] })
  pageKeys: number[];

  $refs!: {
    table: ElTable,
  };
  $configuration!: IConfiguration;

  get configuration() {
    return this.$configuration.formatEditor.behavior.format.editor.object.behaviors.comboSelect;
  }

  sizeStyleProperties() {
    return {
      width: "20px",
      height: "20px",
    };
  }

  colorStyleProperties(style: IColorSpecifiable) {
    return ((!instanceOfIEnableSpecifiable(style) || style.isEnable) && (style.color.value !== null))
      ? {
        backgroundColor: style.color.value,
        border: "1px solid",
        borderColor: "inherit",
      }
      : null;
  }

  toMovePageString(movePageBehavior: IMovePageBehavior): string {
    const index = this.pageKeys.indexOf(movePageBehavior.pageKey);
    return movePageBehavior.isEnable && index >= 0
      ? (index + 1).toString()
      : "なし";
  }

  @Watch("options")
  onOptionsUpdated(newValue: IComboOption[], oldValue: IComboOption[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  selectionChange(value: IComboOption[]): void {}
}
